// import joan1 from "../../images/joan1.jpg";
// import joan2 from "../../images/joan2.jpg";
// import joan3 from "../../images/joan3.jpg";
// import joan4 from "../../images/joan4.jpg";
// import joantrio from "../../images/joantrio.jpg";
// import joantrio1 from "../../images/joantrio1.jpg";
// import joantrio2 from "../../images/joantrio2.jpg";
// import joantrio3 from "../../images/joantrio3.jpg";
// import dam1 from "../../images/DamJawn/dam1.jpg";
// import dam2 from "../../images/DamJawn/dam2.jpg";
// import dam3 from "../../images/DamJawn/dam3.jpg";
import JawnDickOatts from "../../images/DamJawn/JawnDickOatts.jpg";
// import dam5 from "../../images/DamJawn/dam5.jpg";
// import dam6 from "../../images/DamJawn/dam6.jpg";
// import dam7 from "../../images/DamJawn/dam7.jpg";
// import dam8 from "../../images/DamJawn/dam8.jpg";
// import dam9 from "../../images/DamJawn/dam9.jpg";
// import dam10 from "../../images/DamJawn/dam10.jpg";
import dam11 from "../../images/DamJawn/dam11.jpg";
import dam12 from "../../images/DamJawn/dam12.jpg";
import dam13 from "../../images/DamJawn/dam13.jpg";
import dam14 from "../../images/DamJawn/dam14.jpg";
import dam15 from "../../images/DamJawn/dam15.jpg";
import JFTrio1 from "../../images/JFTrio1.jpg";
// import JFTrio2 from "../../images/JFTrio2.jpg";
import JFTrio3 from "../../images/JFTrio3.jpg";
import JFTriofeatTimothyBanchet1 from "../../images/JF Trio feat. Timothy Banchet 1.jpg";

import JeremyPelt from "../../images/JeremyPelt.jpg";
import JeremyPelt2 from "../../images/JeremyPelt2.jpg";
import JoanFortTrioFeatVincentHerring from "../../images/Joan Fort Trio feat. Vincent Herring.jpg";
import JoanFortHeadshot from "../../images/JoanFortHeadshot.jpg";
import TheDamJawnFeatJeremyPelt from "../../images/The Dam Jawn feat. Jeremy Pelt.jpg";
import VincentHerringJoanFortTrio from "../../images/Vincent Herring & Joan Fort Trio.jpg";
import VincentHerringJoanFort from "../../images/Vincent Herring & Joan Fort.jpg";

import Trio1 from "../../images/Trio1.jpg";
import Trio2 from "../../images/Trio2.jpg";
import Trio3 from "../../images/Trio3.jpg";

const images = [
  {
    original: JoanFortTrioFeatVincentHerring,
    thumbnail: JoanFortTrioFeatVincentHerring,
    loading: "lazy",
    description: "Joan Fort Trio feat. Vincent Herring",
  },
  {
    original: JoanFortHeadshot,
    thumbnail: JoanFortHeadshot,
    loading: "lazy",
    description: "Joan Fort Headshot",
  },
  {
    original: TheDamJawnFeatJeremyPelt,
    thumbnail: TheDamJawnFeatJeremyPelt,
    loading: "lazy",
    description: "The Dam Jawn feat Jeremy Pelt",
  },
  {
    original: VincentHerringJoanFortTrio,
    thumbnail: VincentHerringJoanFortTrio,
    loading: "lazy",
    description: "Vincent Herring & Joan Fort Trio",
  },
  {
    original: VincentHerringJoanFort,
    thumbnail: VincentHerringJoanFort,
    loading: "lazy",
    description: "Vincent Herring & Joan Fort",
  },
  {
    original: JeremyPelt,
    thumbnail: JeremyPelt,
    loading: "lazy",
    description: "Jeremy Pelt",
  },

  {
    original: JeremyPelt2,
    thumbnail: JeremyPelt2,
    loading: "lazy",
    description: "Jeremy Pelt",
  },
  {
    original: Trio1,
    thumbnail: Trio1,
    loading: "lazy",
    description: "Joan Fort Trio",
  },
  {
    original: Trio2,
    thumbnail: Trio2,
    loading: "lazy",
    description: "Joan Fort Trio",
  },
  {
    original: Trio3,
    thumbnail: Trio3,
    loading: "lazy",
    description: "Joan Fort Trio",
  },
  {
    original: JFTrio1,
    thumbnail: JFTrio1,
    loading: "lazy",
    description: "Joan Fort Trio",
  },
  {
    original: JFTrio3,
    thumbnail: JFTrio3,
    loading: "lazy",
    description: "Joan Fort Trio",
  },

  {
    original: JFTriofeatTimothyBanchet1,
    thumbnail: JFTriofeatTimothyBanchet1,
    loading: "lazy",
    description: "Joan Fort Trio feat. Timothy Banchet",
  },

  {
    original: dam11,
    thumbnail: dam11,
    loading: "lazy",
    description: "The Dam Jawn",
  },
  {
    original: dam12,
    thumbnail: dam12,
    loading: "lazy",
    description: "The Dam Jawn",
  },
  {
    original: dam13,
    thumbnail: dam13,
    loading: "lazy",
    description: "The Dam Jawn",
  },
  {
    original: dam14,
    thumbnail: dam14,
    loading: "lazy",
    description: "The Dam Jawn",
  },
  {
    original: dam15,
    thumbnail: dam15,
    loading: "lazy",
    description: "The Dam Jawn",
  },
  {
    original: JawnDickOatts,
    thumbnail: JawnDickOatts,
    loading: "lazy",
    description: "The Dam Jawn",
  },
];

export default images;
